import script from "./NavigationTapbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationTapbar.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationTapbar.vue?vue&type=style&index=0&id=084d567b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084d567b"]])

export default __exports__